import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { zodResponseFormat } from "openai/helpers/zod";
import { useEffect, useRef, useState } from "react";
import { Stepper } from "react-form-stepper";
import { MdDownloadDone, MdMic, MdMicOff } from "react-icons/md";
import { TailSpin, ThreeDots } from 'react-loader-spinner';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { z } from "zod";
import useApiFetcher from "../../../hooks/useApiFetcher";
import { avatarAppConfig } from "../../Avatar/config";
import {
  createAvatarSynthesizer,
  createWebRTCConnection
} from "../../Avatar/Utility";
import Board from "../PitchAimee/Board";
import styles from "./Avatar.module.css";
import SelectionLayout from "./SelectionLayout/SelectionLayoutPitch";
import Form from "./Form";
import Logo from "../../../Images/icons/logo.png";
import { useTheme } from "../../BrandColors/Context/ThemeContext";

let scriptArr = [];
var isSpeakingEnabled = false;
const priceArr = [];
let statusArr;
const coreFeature = []
let lastScreen = false
let productScriptPrompt = [];
let introPrompt = []
const Avatar = () => {

  const user = JSON.parse(localStorage.getItem("user"));
  const [userName, setUserName] = useState("");
  const [userQueriesHistory, setUserQueriesHistory] = useState([]);
  useEffect(() => {
    if (user?.role === "DealershipAdmin") {
      setUserName(user?.dealershipId?.dealershipName);
    } else {
      setUserName("");
    }
  }, [user]);

  const dealershipTheme = useTheme()
  let debounceTimeout;
  const [boardData, setBoardData] = useState([]);
  const [showBoardBtn, setShowBoardBtn] = useState(false)
  const [boardBtnText, setboardBtnText] = useState("")
  const [searchParams] = useSearchParams();
  const dealId = searchParams.get('deal');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dynamicSteps, setDynamicSteps] = useState();
  const [status, setStatus] = useState([])
  const [labels, setlabels] = useState([])
  const [tempArr, setTempArr] = useState(Array(priceArr.length).fill(0));
  const [totalPrice, setTotalPrice] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState("")
  const [isThinking, setIsThinking] = useState(false)
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [submitBtn, setSubmitBtn] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [showFinalSummaryScreen, setShowFinalSummaryScreen] = useState(false);
  const [summaryScreen, setSummaryScreen] = useState(false);
    const [qaHistory, setQaHistory] = useState([]); 

  const handleFocus = () => {
    setIsActive(true);
  };
  const handleBlur = () => {
    setIsActive(false);
  };
  const handleOnSubmit = () => {
    console.log("Submit btn before handleUserHistory:", submitBtn);
    handleUserHistory(submitBtn);
    setSubmitBtn("");
    setIsActive(false);
  };
   function storeQA(question, answer) {
    setQaHistory(prev => [...prev, { question, answer }]);
  }
  useEffect(() => {
    updatePrices(status)
    console.log("CALL", priceArr)
  }, [status, showFinalSummaryScreen, summaryScreen])
  const updatePrices = (updatedStatusArr) => {
    // Update tempArr based on updatedStatusArr
    if (apiData) {
      console.log(priceArr, 'pricesArrinAvatar')
      console.log("CLICKED PRICE ARRAY", tempArr, priceArr)
      const newTempArr = updatedStatusArr.map((status, index) =>
        status ? priceArr[index] : 0
      );
      console.log(newTempArr, "newTempArr");

      // Calculate the total price
      const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);

      function calculatePMT(rate, nper, pv) {
        if (pv === 0) return 0; // If loan amount is zero, no payment needed
        if (nper <= 0) return 0; // Avoid division errors
        if (rate === 0) return pv / nper; // Simple division when rate is zero
        console.log("LOAN Amount", typeof (pv))
        console.log("nper", typeof (nper))
        console.log("rate", typeof (rate))

        rate = rate / 100;
        const monthlyRate = rate / 12;
        const pmt = (monthlyRate * pv) / (1 - Math.pow(1 + monthlyRate, -nper));
        return pmt;
      }
      const annualInterestRate = Number(`${apiData?.deal.intrestedRate}`);
      const totalPeriods = Number(`${apiData?.deal.financeDuration}`);
      const allSelected = updatedStatusArr.every(status => status === true);
      const summaryStep = apiData?.getScript?.steps.find(
        (step) => step.type === "Summary Script"
      );
      console.log(summaryStep, "summaryStep")
      const discountPercentage = Number(summaryStep?.discountPercent ?? 0);
      console.log(discountPercentage, "discountPercentage")
      const discountTotalPayment = allSelected
        ? newTotalPrice * (1 - discountPercentage / 100)
        : newTotalPrice;

      console.log(discountTotalPayment, 'discountTotalPaymentinAvatar.js')

      const loanAmount = discountTotalPayment + Number(`${apiData?.deal.financeAmount}`)
      const monthlyPayment = calculatePMT(annualInterestRate, totalPeriods, loanAmount);
      console.log(monthlyPayment, 'monthlyPaymentInAvatar.js')
      // Update state
      console.log("newTempArr", newTempArr)
      console.log("newTotalPrice", newTotalPrice)
      console.log("Discount Applied:", allSelected ? `${discountPercentage}%` : "No Discount");
      console.log("discountTotalPayment", discountTotalPayment)
      console.log("monthlyPayment", monthlyPayment)
      setTempArr(newTempArr);
      setTotalPrice(discountTotalPayment);
      setMonthlyPayment(monthlyPayment)
    }
  };
  console.log("dynamicsteps", dynamicSteps)
  console.log('labels', labels)
  const { apiFetcher } = useApiFetcher();
  const [loading, setLoading] = useState(false);
  const [start, setStart] = useState(true);
  const [index, setIndex] = useState(0);
  const [avatarSynthesizer, setAvatarSynthesizer] = useState(null);
  const [microphoneEnabled, setMicrophoneEnabled] = useState(true);
  var [speechRecognizer, setSpeechRecognizer] = useState(null);
  const [isDisable, setIsDisable] = useState(true);
  const [isListening, setIsListening] = useState(false);
  const [formData, setFormData] = useState(null);
  const [apiData, setApiData] = useState("");
  const [dynamicPrompt, setDynamicPrompt] = useState("")


  const initializeScript = (script, productPrice) => {
    priceArr.length = 0;
    coreFeature.length = 0
    let labelsArray = [];
    productScriptPrompt = []
    introPrompt = []
    script.forEach((step) => {
      if (step.type === "Product Script") {
        labelsArray.push(step.stepTitle)
        priceArr.push(Number(step.price))
        coreFeature.push(step.corsText)
        productScriptPrompt.push(step.script)
      }
      if (step.type === "Intro") {
        introPrompt.push(step.script)
      }
    });
    statusArr = Array(labelsArray.length).fill(true);
    const dynamicSteps = script.map((item, idx) => ({
      label: item.stepTitle,
      id: idx,
    }));
    setlabels(labelsArray)
    setDynamicSteps(dynamicSteps);
    setStatus(statusArr);
  };

  console.log('apidata', apiData)
  console.log(priceArr, 'PriceArray');
  useEffect(() => {
    if (!window.hasInitialized) {
      console.log('window wala useEefet')
      const fetchData = async () => {
        const response = await apiFetcher(`/int-dealerships/${dealId}/script`);
        const formData = {
          avatar: response.deal.avatar.split(",")[0],
          style: response.deal.avatar.split(",")[1],
          voice: response.deal.voice,
        };
        setApiData(response)
        setFormData(formData);
        setDynamicPrompt(response.getScript.aiPrompt)
        const productPrice = response?.deal.productPrices
        const script = response?.getScript?.steps;
        initializeScript(script, productPrice);
        window.hasInitialized = true;
      };
      fetchData();
    }
  }, []);
  function splitSentences(text) {
    // Regex to match sentence-ending punctuation (., !, ?) followed by spaces
    const sentenceRegex = /([.!?])\s+/g;

    const sentences = [];
    let lastIndex = 0;

    // Iterate over the matches to split sentences
    text.replace(sentenceRegex, (match, punctuation, offset) => {
      // Extract the sentence up to the matched punctuation and trim leading/trailing spaces
      const sentence = text.slice(lastIndex, offset + punctuation.length).trim();

      if (sentence) {
        // If the sentence is shorter than 15 characters, don't split
        if (sentence.length < 15) {
          if (sentences.length > 0) {
            // Add the sentence to the last one (concatenation)
            sentences[sentences.length - 1] += " " + sentence;
          } else {
            sentences.push(sentence);
          }
        } else {
          sentences.push(sentence);
        }
      }
      lastIndex = offset + punctuation.length; // Update the last index for the next slice
      return match;
    });

    const remainingText = text.slice(lastIndex).trim();
    if (remainingText) {
      sentences.push(remainingText);
    }

    return sentences;
  }
  useEffect(() => {
    if (!loading) {
      console.log('insecond useEfect loading wala')
      const fetchData = async () => {
        try {
          const response = await apiFetcher(`/int-dealerships/${dealId}/script`);
          const script = response?.getScript?.steps;
          if (!window.hasInitialized) {
            initializeScript(script);
          }
          const currentScript = script[index]?.script || "";
          console.log(currentScript, 'line 441')
          setCurrentIndex(index);
          scriptArr = splitSentences(currentScript);
          console.log(scriptArr, "scriptArr")
          isSpeakingEnabled = true;
          speakSelectedText();
          const summaryScriptAvailable = script.some(step => step.type === "Summary Script");
          if (!summaryScriptAvailable) {
            setIsDisable(false)
          }
          console.log("summaryScriptAvailable", summaryScriptAvailable)
          if (script[index]?.type === "Summary Script") {
            setSummaryScreen(true);
            setIsDisable(false)
            scriptArr.push(`your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`)
            console.log("SHOW Total Added", scriptArr)
          }
          if (script[index]?.type === "Final Script") {
            setShowFinalSummaryScreen(true)
            lastScreen = true
          }
        } catch (error) {
          console.error("Error fetching script data:", error);
        }
      };
      fetchData();
    }
  }, [loading, index]);

  const myAvatarVideoEleRef = useRef();
  const myAvatarAudioEleRef = useRef();
  const myAvatarCanvasRef = useRef(null);
  const disconnectRef = useRef();
  const iceUrl = avatarAppConfig.iceUrl;
  const iceUsername = avatarAppConfig.iceUsername;
  const iceCredential = avatarAppConfig.iceCredential;
  const cogSvcRegion = avatarAppConfig.cogSvcRegion;
  const cogSvcSubKey = avatarAppConfig.cogSvcSubKey;
  const geminiAPIKey = process.env.REACT_APP_GEMINI_API_KEY || avatarAppConfig.geminiAPIKey;
  const sarvamAPIKey = avatarAppConfig.sarvamAPIKey;
  useEffect(() => {
    window.addEventListener("beforeunload", handleWindowClose);
    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);

  const startSession = () => {
    console.log("Start..");
    setLoading(true);
    const peerConnection = createWebRTCConnection(
      iceUrl,
      iceUsername,
      iceCredential
    );
    peerConnection.ontrack = handleOnTrack;
    peerConnection.addTransceiver("video", { direction: "sendrecv" });
    peerConnection.addTransceiver("audio", { direction: "sendrecv" });

    const avatarSynth = createAvatarSynthesizer(formData); // Pass formData
    setAvatarSynthesizer(avatarSynth);

    peerConnection.oniceconnectionstatechange = (e) => {
      console.log("WebRTC status: " + peerConnection.iceConnectionState);
      if (peerConnection.iceConnectionState === "connected") {
        console.log("Connected to Azure Avatar service");
      }
      if (
        peerConnection.iceConnectionState === "disconnected" ||
        peerConnection.iceConnectionState === "failed"
      ) {
        console.log("Azure Avatar service Disconnected");
        window.location.reload();
      }
    };

    avatarSynth
      .startAvatarAsync(peerConnection)
      .then(() => {
        console.log("Avatar started.");
        const timer = setTimeout(() => {
          setLoading(false);
          setStart(false);
        }, 3000);
      })
      .catch((error) => {
        console.log("Avatar failed to start. Error: " + error);
        setLoading(false); // Ensure loading stops even on failure
        window.location.reload();
      });

    const speechRecognitionConfig = SpeechSDK.SpeechConfig.fromEndpoint(
      new URL(
        `wss://${cogSvcRegion}.stt.speech.microsoft.com/speech/universal/v2`
      ),
      cogSvcSubKey
    );
    speechRecognitionConfig.setProperty(
      SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode,
      "Continuous"
    );
    const sttLocales = ["en-US", "de-DE", "es-ES"];
    const autoDetectSourceLanguageConfig =
      SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(sttLocales);
    const speechRecog = SpeechSDK.SpeechRecognizer.FromConfig(
      speechRecognitionConfig,
      autoDetectSourceLanguageConfig,
      SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
    );
    setSpeechRecognizer(speechRecog);



  };
  const handleStepperClick = (e) => {
    if (isSpeaking && !isListening && !isThinking) {
      const clickedStep = parseInt(e.target.innerText, 10);
      console.log("CLICKED STEP", clickedStep)
      lastScreen = false
      scriptArr = []
      setIndex(clickedStep - 1)
    }

  }
  const handleOnTrack = (event) => {
    if (event.track.kind === "video") {
      const mediaPlayer = myAvatarVideoEleRef.current;
      mediaPlayer.id = event.track.kind;
      mediaPlayer.srcObject = event.streams[0];
      mediaPlayer.autoplay = true;
      mediaPlayer.playsInline = true;
      mediaPlayer.addEventListener("play", () => {
        window.requestAnimationFrame(() => { });
      });
    } else {
      const audioPlayer = myAvatarAudioEleRef.current;
      audioPlayer.srcObject = event.streams[0];
      audioPlayer.autoplay = true;
      audioPlayer.playsInline = true;
      audioPlayer.muted = true;
    }
  };

  const statusArraySchema = z.array(z.boolean());
  const responseSchema = z.object({
    answer: z.string(),
    array: statusArraySchema,
  });

  const handleUserHistory = async (userQuery) => {
    setIsThinking(true)
    setUserQueriesHistory((prevHistory) => [...prevHistory, { question: userQuery, answer: null }]);
    const slot_prompt = `
${introPrompt
        .map((step) => `Intro: ${step.script || "No script provided"}`)
        .join("\n")}
        You are an assistant managing a list of service packages for a customer. The customer previously discussed the following services, with an initial selection status as follows:

        ${productScriptPrompt
        .map((step, index) => `${labels[index]} : ${step}`)
        .join("\n")}
  
        The customer’s initial selection status is represented by an array:
        ${JSON.stringify(status)}, where each position corresponds to a service:
       ${labels
        .map(
          (step, index) => `- Position ${index}: ${labels[index]}  -- initial selection status : ${status[index]}`
        )
        .join("\n")}
  
        Instructions:
        ${dynamicPrompt}
        
        **** IMPORTANT NOTE****
        ONLY USE WHEN USER ASK ABOUT ANY EMI CALCULATION EMI Calculation Instructions: To calculate your monthly EMI (Equated Monthly Installment), use the following formula: EMI = (P * r * (1 + r)^n) / ((1 + r)^n - 1), where P is the loan amount, r is the monthly interest rate, and n is the number of months. tell me only answer don't tell formula if interest rate is not available take 7 % also tell user interest rate all other value they tell answer.
        Updated status array reflecting any changes, with each position as true or false
        **NOTE **  
         - This Data only use when some one ask about any this from this data ${JSON.stringify(apiData.deal, null, 2)}  and Monthly Price is ${monthlyPayment}
         - Give Answer in 2 to 4 line only if user ask tell me in detail or ask in brif then give in brif
         *** This is Question and its Answer previously discussed with the customer, so you can use this information to answer the current question. *** 
         -${qaHistory.map((qa) => `Question: ${qa.question} Answer: ${qa.answer}`).join("\n")}
         }
        `;

    const isQuestionInquiry = /\b(what is|what's|whats|what are|explain|tell me about|how does|what does|why do|why should|why would|info on|details on|meaning of|definition|is it worth|should i get|do i need|describe|how much|\?)\b/i.test(userQuery);

    // API Request Setup with Google Gemini AI
    const activeKey = geminiAPIKey || sarvamAPIKey;
    const isGemini = !!geminiAPIKey;
    const bodyPayload = {
      model: isGemini ? "gemini-2.5-flash" : "sarvam-105b",
      messages: [
        { role: "system", content: slot_prompt + "\n\nYou MUST respond ONLY with a valid JSON object. The JSON object must have exactly two properties: \"answer\" (a string with your verbal response) and \"array\" (an array of booleans representing the selection status of the items). If the user is asking a question or for information/explanation, DO NOT modify the selection status array—keep each boolean exactly as provided in the initial selection status array! Do not include any markdown formatting, backticks, or any other text." },
        { role: "user", content: userQuery },
      ],
      max_tokens: 400,
      temperature: 0.3
    };

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${activeKey}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(bodyPayload),
      redirect: "follow",
    };

    try {
      const endpoint = isGemini
        ? "https://generativelanguage.googleapis.com/v1beta/openai/chat/completions"
        : "https://api.sarvam.ai/v1/chat/completions";

      const response = await fetch(endpoint, requestOptions);
      console.log("Prompt:", slot_prompt);
      const data = await response.json();
      let parsedResponse = data.choices?.[0]?.message?.content || "";
      console.log("Raw Response:", parsedResponse);
      
      // Strip markdown backticks if the model added them anyway
      parsedResponse = parsedResponse.replace(/```json/gi, "").replace(/```/g, "").trim();
      
      let answer, updatedStatusArr;
      try {
          const parsed = JSON.parse(parsedResponse);
          answer = parsed.answer;
          updatedStatusArr = parsed.array;
      } catch (e) {
          console.warn("AI returned text instead of JSON. Falling back to plain text answer.");
          updatedStatusArr = statusArr; // Fallback to original array
          
          // Try to rescue the answer if it was just truncated JSON
          const answerMatch = parsedResponse.match(/"answer"\s*:\s*"([^]*?)"(?:(?=\s*,)|(?=\s*\}))/);
          if (answerMatch && answerMatch[1]) {
              answer = answerMatch[1];
          } else {
              // Clean out the JSON garbage and the array part so Aimee doesn't speak it aloud
              answer = parsedResponse
                  .replace(/```json/gi, "")
                  .replace(/```/g, "")
                  .replace(/"array"\s*:\s*\[.*?\]/g, "") // Remove array if complete
                  .replace(/"array"\s*:\s*\[.*/g, "") // Remove array if truncated
                  .replace(/[{}]/g, "")
                  .replace(/"answer"\s*:/gi, "")
                  .replace(/"/g, "")
                  .replace(/true/gi, "")
                  .replace(/false/gi, "")
                  .trim();
          }
      }
         storeQA(userQuery, answer);
      console.log("Model Response:", answer, updatedStatusArr);
      setIsThinking(false)
      setUserQueriesHistory((prevHistory) => {
        const updatedHistory = [...prevHistory];
        updatedHistory[updatedHistory.length - 1].answer = answer;
        return updatedHistory;
      });
      for (let index = 0; index < updatedStatusArr.length; index++) {
        const status = updatedStatusArr[index];
        if (status !== statusArr[index]) {
          if (status) {
            console.log(`Service reselected: ${labels[index]}`);
            await updatePrices(updatedStatusArr); // Wait for updatePrices to finish
            isSpeakingEnabled = true;
            statusArr = [...updatedStatusArr];
            setStatus(updatedStatusArr);
            const newTempArr = updatedStatusArr.map((status, i) => (status ? priceArr[i] : 0));
            const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
            speakSelectedText(`Great choice! That’s a fantastic addition ${labels[index]} to your cart! I’m sure you’ll really enjoy it. Right now, your total amount is ${newTotalPrice} dollars. If you’d like to add or change anything, feel free to let me know. I’m happy to assist you further!`);
            return;
          } else {
            console.log("ARR UN ", `  ${labels[index]}`);
            await updatePrices(updatedStatusArr); // Wait for updatePrices to finish
            isSpeakingEnabled = true;
            statusArr = [...updatedStatusArr];
            setStatus(updatedStatusArr);
            const newTempArr = updatedStatusArr.map((status, i) => (status ? priceArr[i] : 0));
            const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
            speakSelectedText(`Oh, I see you’ve decided to remove ${labels[index]}. No worries, I totally understand—it’s all about finding what works best for you! If you change your mind or need more information on any other options, feel free to ask. As of now, your total amount is ${newTotalPrice} dollar. Let me know if you'd like to make any other adjustments or if you need assistance with anything else!`);
            return;
          }
        }
      }
      // Update Status Array
      isSpeakingEnabled = true;
      speakSelectedText(answer);
      statusArr = [...updatedStatusArr];
      setStatus(updatedStatusArr)
    } catch (error) {
      console.error("Error fetching or parsing response:", error);
    }
  };

  // handleUserHistory("what is service contract")
  const stopSession = () => {
    if (avatarSynthesizer) {
      console.log("stop");
      avatarSynthesizer
        .stopSpeakingAsync()
        .then(() => {
          avatarSynthesizer.close();
        })
        .catch((error) => {
          console.log("Error stopping session", error);
        });
    }
  };
  let count = 0

  const speakSelectedText = (query) => {
    setIsSpeaking(false);
    const audioPlayer = myAvatarAudioEleRef.current || {};
    audioPlayer["muted"] = false;
    let finaltextToSpeak = "";
    const lastSentence = scriptArr?.[scriptArr.length - 1];//it will give us the last sentence in script
    console.log(lastSentence, 'lastsentence')

    if (!isSpeakingEnabled) {
      return;
    }
    if (!query) {
      finaltextToSpeak = scriptArr.shift();
    } else {
      finaltextToSpeak = query;
    }

    if (finaltextToSpeak === undefined) {
      return;
    }

    const notepadContents = apiData?.getScript?.steps?.[index]?.notepadContents;
    console.log(notepadContents, 'notepadContents')
    const buttonText = apiData?.getScript?.steps?.[index]?.buttonText

    if (notepadContents && typeof notepadContents === "object") {
      // let isLastSentence = false;

      const sanitizedFinalText = finaltextToSpeak.trim().replace(/[^\w\s]/g, "").toLowerCase();
      const sanitizedLastSentence = lastSentence?.trim()?.replace(/[^\w\s]/g, "").toLowerCase();
      // Check if the last sentence is being spoken
      if (sanitizedFinalText === sanitizedLastSentence) {
        console.log(sanitizedLastSentence, 'found our match in last sentence')
        // isLastSentence = true;
        setShowBoardBtn(true)
        setboardBtnText(buttonText)
      }
      // Loop through the object
      for (const key in notepadContents) {
        console.log("key", key);

        const sanitizedfinaltextToSpeak = finaltextToSpeak
          .trim()
          .replace(/[^\w\s]/g, "")
          .toLowerCase(); // Normalize case for comparison
        const sanitizedkey = key
          .trim()
          .replace(/[^\w\s]/g, "")
          .toLowerCase(); // Normalize case for comparison

        const isTextIncluded = sanitizedfinaltextToSpeak.includes(sanitizedkey);
        console.log("isTextIncluded", isTextIncluded);

        if (isTextIncluded) {
          console.log("Found matching key in notepad:", key);
          console.log("Notepad Object:", notepadContents[key]);

          // Update board data
          setBoardData(notepadContents[key]);
          if (notepadContents[key].isButton) {
            console.log("Button is set to true for this key.");
          }

          break;
        }
      }
    } else {
      console.log("notepadContents is not valid or is not an object.");
    }

    if (finaltextToSpeak && avatarSynthesizer) {
      avatarSynthesizer
        .speakTextAsync(finaltextToSpeak)
        .then((result) => {
          if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
            console.log("Speech and avatar synthesized to video stream.");
            console.log("Avatar has finished speaking.");
            if (scriptArr.length > 0) {
              speakSelectedText();
            } else {
              // If no more sentences, trigger any final actions
              setIsSpeaking(true);
            }
          } else {
            console.log("Unable to speak. Result ID: " + result.resultId);
            if (result.reason === SpeechSDK.ResultReason.Canceled) {
              const cancellationDetails = SpeechSDK.SpeakerAudioDestination.CancellationDetails.fromResult(result);
              console.log("Canceled. Reason: " + cancellationDetails.reason);
              if (cancellationDetails.reason === SpeechSDK.CancellationReason.Error) {
                console.log("Error details: " + cancellationDetails.errorDetails);
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error in speakTextAsync:", error);
        });
    } else if (finaltextToSpeak && !avatarSynthesizer) {
        console.warn("Avatar synthesizer is not initialized yet. Skipping speech.");
    } else {

    }
  };

  const applyChromaKeyEffect = () => {
    const video = myAvatarVideoEleRef.current;
    const canvas = myAvatarCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const chromaKey = () => {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const frame = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = frame.data;

      const greenThreshold = {
        rMin: 0,
        rMax: 100,
        gMin: 100,
        gMax: 255,
        bMin: 0,
        bMax: 100,
      };
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        if (
          r >= greenThreshold.rMin &&
          r <= greenThreshold.rMax &&
          g >= greenThreshold.gMin &&
          g <= greenThreshold.gMax &&
          b >= greenThreshold.bMin &&
          b <= greenThreshold.bMax
        ) {
          data[i + 3] = 0; // Set alpha to 0 for transparency
        }
      }

      ctx.putImageData(frame, 0, 0);
      requestAnimationFrame(chromaKey);
    };

    video.addEventListener("play", () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      chromaKey();
    });
  };

  const handleWindowClose = (event) => {
    console.log("User is trying to refresh or close the window");
    event.preventDefault();
    if (disconnectRef.current) {
      console.log("DIS");
      disconnectRef.current.click();
    }
  };

  const microphone = async (e) => {

    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (!isSpeaking) return
    console.log("mic button clicked");
    isSpeakingEnabled = false;

    avatarSynthesizer
      .stopSpeakingAsync()
      .then(() => {
        setIsListening(true);
        console.log(
          "[" + new Date().toISOString() + "] Stop speaking request sent."
        );
      })
      .catch();
    speechRecognizer.recognized = async (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        let userQuery = e.result.text.trim();
        console.log("userQuery", userQuery);
        // speakSelectedText()
        if (userQuery === "") {
          return;
        }
        handleUserHistory(userQuery);

        const continuousConversation = false;
        if (!continuousConversation) {
          setMicrophoneEnabled(false);
          speechRecognizer.stopContinuousRecognitionAsync(
            () => {
              setMicrophoneEnabled(true);
              setIsListening(false);
            },
            (err) => {
              console.log("Failed to stop continuous recognition:", err);
              setMicrophoneEnabled(true);
            }
          );
        }
      }
    };

    speechRecognizer.startContinuousRecognitionAsync(
      () => {
        setMicrophoneEnabled(true);
      },
      (err) => {
        console.log("Failed to start continuous recognition:", err);
        setMicrophoneEnabled(true);
      }
    );
  };
  const stopMicrophone = async () => {
    try {
      console.log("Stopping microphone...");
      setIsListening(false);
      setMicrophoneEnabled(true);
      await avatarSynthesizer.stopSpeakingAsync();
      console.log("Avatar stopped speaking.");

      speechRecognizer.stopContinuousRecognitionAsync(
        () => {
          console.log("Speech recognition stopped.");
          setMicrophoneEnabled(true);
        },
        (err) => {
          console.error("Failed to stop continuous recognition:", err);
        }
      );
    } catch (error) {
      console.error("Error while stopping the microphone:", error);
    }
  };
  const handleMicClick = (action) => {
    clearTimeout(debounceTimeout); // Clear previous debounce timer
    debounceTimeout = setTimeout(() => {
      if (action === "start") {
        microphone();
      } else if (action === "stop") {
        stopMicrophone();
      }
    }, 500); // Adjust debounce delay as needed
  };

  return (
    <>{apiData ?
      <div className={styles.mainAvatarContainer}>
        <div className={styles.notpadmain}>
          <div className={styles.myAvatarDemoText}>Sailsense Pitch Deck</div>
          <div>
            <Stepper
              steps={dynamicSteps}
              activeStep={currentIndex}
              className={styles.stepperStep}
              onClick={(e) => handleStepperClick(e)}

              styleConfig={{
                activeBgColor: "#2e97d8",
                completedBgColor: "#2f44bc",
                inactiveBgColor: "#E5E7EB",
                activeTextColor: "#ffffff",
                completedTextColor: "#ffffff",
                inactiveTextColor: "#000000",
              }}
            />
            <div className={styles.newContainer}>
              <div className={styles.Avatar}>
                <div className={styles.container}>
                  <div className={styles.videoContainer}>
                    {start ? (
                      <div className={styles.loading}>

                        {loading ? (
                          <div className={styles.loader}></div>
                        ) : (
                          <>
                            <div className={styles.loadingcontainer}>
                              <div className={styles.welcomeBox}>
                                <h1 className={styles.greeting}>
                                  I want to work for you, {apiData?.deal?.dealershipName}
                                </h1>
                                {apiData && <button className={styles.startButton} onClick={startSession}>
                                  Start Now
                                </button>}
                              </div>
                            </div>
                          </>
                        )
                        }
                      </div>
                    ) : (
                      null
                    )}

                    <div className={styles.videoDiv}>
                      <video
                        className="myAvatarVideoElement"
                        ref={myAvatarVideoEleRef}
                        onLoadedData={applyChromaKeyEffect}
                        style={{ display: "none" }}
                      />
                      <audio ref={myAvatarAudioEleRef} />
                      <canvas ref={myAvatarCanvasRef} className={styles.myAvatarCanvas} />
                    </div>
                  </div>
                  <div className={styles.btnContainer}>
                    <>
                      {isThinking ?
                        <>
                          <div className={styles.thinkingLoader}>
                            <ThreeDots
                              visible={true}
                              height="40"
                              width="40"
                              color="#fff"
                              radius="9"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                            />
                          </div>
                        </>
                        :
                        <>
                          {/* <div className={styles.btnContainer}> */}
                          {!isSpeaking || isListening ? (
                            <textarea
                              className="styledTextarea"
                              placeholder="Write here..."
                              onFocus={handleFocus}
                              onBlur={handleBlur}
                              disabled={true}
                              onChange={(e) => {
                                console.log("Textarea input:", e.target.value);
                                setSubmitBtn(e.target.value);
                              }}
                              value={submitBtn}

                            ></textarea>

                          ) :
                            (
                              <textarea
                                className="styledTextarea"
                                placeholder="Write here..."
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                disabled={isDisable}
                                onChange={(e) => {
                                  console.log("Textarea input:", e.target.value);
                                  setSubmitBtn(e.target.value);
                                }}
                                value={submitBtn}

                              ></textarea>
                            )}

                          {isActive ? (
                            <button
                              disabled={!isSpeaking}
                              className={styles.mic}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={handleOnSubmit}
                            >
                              <MdDownloadDone />
                            </button>
                          ) :
                            (
                              <>
                                <button disabled={isDisable} className={`${isListening ? styles.micDisable : styles.mic}`}>
                                  {isListening ? (
                                    <MdMicOff onClick={() => handleMicClick("stop")} />
                                  ) : (
                                    <MdMic onClick={() => handleMicClick("start")} />
                                  )}
                                </button>
                              </>
                            )}
                          {/* </div> */}
                        </>
                      }
                    </>
                  </div>
                </div>
                <div>
                  <button
                    ref={disconnectRef}
                    className={styles.btn}
                    onClick={stopSession}
                    style={{ "display": "none" }}
                  >
                    {" "}
                    Disconnect{" "}
                  </button>
                </div>
              </div>
              <div className={styles.Board}>
                {!showFinalSummaryScreen ?
                  <>
                    {summaryScreen ? (
                      <SelectionLayout isSpeaking={isSpeaking} isThinking={isThinking} isListening={isListening} apiData={apiData} priceArr={priceArr} coreFeature={coreFeature} index={index} setIndex={setIndex} labels={labels} status={status} setStatus={setStatus} speakSelectedText={speakSelectedText} scriptArr={scriptArr} isSpeakingEnabled={isSpeakingEnabled} tempArr={tempArr} totalPrice={totalPrice} monthlyPayment={monthlyPayment} userQueriesHistory={userQueriesHistory} statusArr={statusArr} />
                    ) : (
                      <>
                        <Board
                          key={`${boardData?.images}-${boardData?.subHeading}-${boardData?.sentence}`}
                          // isButton={boardData?.isButton}
                          // buttonText={boardData?.buttonText}
                          boardBtnText={boardBtnText}
                          setboardBtnText={setboardBtnText}
                          showBoardBtn={showBoardBtn}
                          setShowBoardBtn={setShowBoardBtn}
                          isSpeaking={isSpeaking}
                          // key={dataArray[currentIndex].id}
                          index={index}
                          setIndex={setIndex}
                          images={boardData?.images}
                          heading={boardData?.heading}
                          subHeading={boardData?.subHeading}
                          mainContent={boardData?.sentence}
                          tableData={apiData?.deal}
                        />
                      </>
                    )}
                  </> :
                  <>
                    <Form />
                  </>}
                {/* <img src={Logo} className="BoardLogo" /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <TailSpin
          height="80"
          width="80"
          color="#4fa94d"
          ariaLabel="loading"
        />
      </div>}</>
  );
};
export default Avatar;
